import React from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Box } from "@mui/material";

import AppNavbar from "./components/AppNavbar";
import AIPanelLayout from "./layouts/AIPanelLayout";
import PortfolioPage from "./pages/PortfolioPage";
import ProfilePage from "./pages/ProfilePage";
import Market from "./pages/Market"; // ✅ вместо AIAvatars
import Dashboard from "./pages/Dashboard";
import Stake from "./pages/Stake";
import Stream from "./pages/Stream";
import StreamEventPage from "./components/StreamEventPage";
import PredictionEventPage from "./components/PredictionEventPage";


import ClientDashboard from "../pages/ClientDashboard";
import AdminPanel from "../pages/AdminPanel";

import ProtectedRoute from "../components/ProtectedRoute";
import Footer from "../components/Footer";

const RwaApp = () => {
  const location = useLocation();
  const hideFooter = location.pathname === "/chat";

  return (
    <Box
      sx={{
        background:
          "radial-gradient(1200px circle at 12% -10%, rgba(56,189,248,.18), transparent 55%), radial-gradient(900px circle at 92% 0%, rgba(37,99,235,.14), transparent 52%), #020617",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <AppNavbar />

      <Box component="main" sx={{ pt: 2, flexGrow: 1 }}>
        <Routes>
          {/* ✅ ВСЁ, где сайдбар должен быть ВСЕГДА */}
          <Route element={<AIPanelLayout />}>
            {/* ✅ Главная */}
            <Route path="/market" element={<Market />} />
            <Route path="/stream" element={<Stream />} />
        <Route path="/streamevent/:slugAndId" element={<StreamEventPage />} />
        <Route path="/event/:slugAndId" element={<PredictionEventPage />} />

            {/* ✅ редиректы со старых путей */}
            <Route path="/" element={<Navigate to="/market" replace />} />
            <Route path="/avalab" element={<Navigate to="/market" replace />} />
            
            {/* другие страницы внутри панели */}
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/marketplace" element={<Dashboard />} />
            <Route path="/prpay" element={<Stake />} />

            {/* ✅ Личные кабинеты тоже внутри панели (чтобы панель не пропадала) */}
            <Route
              path="/client-dashboard"
              element={
                <ProtectedRoute allowedRole="client">
                  <ClientDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin-panel"
              element={
                <ProtectedRoute allowedRole="admin">
                  <AdminPanel />
                </ProtectedRoute>
              }
            />
          </Route>

          

          
       
          

          {/* (опционально) 404 */}
          <Route path="*" element={<Navigate to="/market" replace />} />
        </Routes>
      </Box>

      {!hideFooter && <Footer />}
    </Box>
  );
};

export default RwaApp;
